// Shared Cognito User Pool session helpers, used by both admin and speaker apps.
// Tokens are stored in localStorage by amazon-cognito-identity-js, which is
// shared across same-origin paths — so signing in via /admin/ persists for
// /present/ too.

import { CognitoUserPool } from 'amazon-cognito-identity-js';

let pool = null;

export function initPool(config) {
  pool = new CognitoUserPool({
    UserPoolId: config.userPoolId,
    ClientId:   config.userPoolClientId,
  });
}

/** Resolves to { idToken, username } if signed in, or null. */
export function existingSession() {
  return new Promise((resolve) => {
    const user = pool?.getCurrentUser();
    if (!user) return resolve(null);
    user.getSession((err, session) => {
      if (err || !session?.isValid()) return resolve(null);
      resolve({ idToken: session.getIdToken().getJwtToken(), username: user.getUsername() });
    });
  });
}

/** Redirect to /admin/?return=<current-url>. */
export function redirectToLogin() {
  const ret = encodeURIComponent(location.pathname + location.search);
  location.replace(`/admin/?return=${ret}`);
}
